module.exports = __webpack_public_path__ + "img/logo.6f14f86f.png";